"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArrowDoubleUp;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowDoubleUp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow-double-up"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.391,37.183a3.385,3.385,0,0,0-4.781,0L8.232,76.559a2.5,2.5,0,0,0,3.536,3.535L50,41.863,88.232,80.1a2.5,2.5,0,0,0,3.536-3.535Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.768,63.073,50,24.842,88.232,63.074a2.5,2.5,0,0,0,3.536-3.535L52.39,20.16a3.386,3.386,0,0,0-4.78,0L8.232,59.538a2.5,2.5,0,0,0,3.536,3.535Z"
  })))));
}